function required(val) {
    return (val && val.length > 0) || "Laukelis privalomas";
}

function email(val) {
    const emailPattern =
        /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;

    return emailPattern.test(val) || "Netinkamas el. pašto formatas";
}

function short(val) {
    return (val && val.length > 3) || "Laukelio rekšmė per trumpa";
}

export default {
    required,
    email,
    short,
};
